function _parseJwt(token) {
  if (!token) {
    return {}
  }

  var base64Url = token.split('.')[1]
  var base64 = base64Url.replace('-', '+').replace('_', '/')
  return JSON.parse(window.atob(base64))
}

function _isValid(token) {
  var payload = _parseJwt(token)
  if (!payload || !payload.exp) {
    return false
  }
  let date = new Date()
  if (date.getTime() < payload.exp * 1000) {
    return true
  }
  return false
}

export default {
  _jwt: null,
  // _refresh_token_expire_at: null,

  getToken() {
    return this._jwt
  },

  set(jwt) {
    if (_isValid(jwt)) {
      this._jwt = jwt
    }
    //  else {
    //     this._jwt = null
    // }
  },

  // setRefreshExpire(expireAt) {
  //     this._refresh_token_expire_at = expireAt
  // },

  // hasValidRefreshToken() {
  //     if (!this._refresh_token_expire_at) {
  //         return false
  //     }

  //     let tokenExpireAt = new Date(this._refresh_token_expire_at);
  //     let now = new Date()
  //     return now < tokenExpireAt
  // },

  destroy() {
    this._jwt = null
    // this._refresh_token_expire_at = null
  },

  isValid() {
    return _isValid(this._jwt)
  },

  getPayload() {
    return _parseJwt(this._jwt)
  },

  getUsername() {
    var payload = this.getPayload()
    if (payload && payload.username) {
      return payload.username
    }
    return null
  },

  hasRole(role) {
    var payload = this.getPayload()
    if (payload && payload.roles && payload.roles.indexOf(role) !== -1) {
      return true
    }
    return false
  },

  isAdmin() {
    return this.hasRole('ROLE_ADMIN')
  }
}
